import { useEffect } from "react";
import Lenis from "lenis";
import ScrollProgress from "@/components/site/ScrollProgress";
import Cursor from "@/components/site/Cursor";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Categories from "@/components/site/Categories";
import Marquee from "@/components/site/Marquee";
import Brands from "@/components/site/Brands";
import Products from "@/components/site/Products";
import WhyOswal from "@/components/site/WhyOswal";
import CompanyProfile from "@/components/site/CompanyProfile";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 0.95 });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen bg-white font-sans text-ink antialiased">
      <ScrollProgress />
      <Cursor />
      <Header />
      <main>
        <Hero />
        <About />
        <Categories />
        <Marquee />
        <Brands />
        <Products />
        <WhyOswal />
        <CompanyProfile />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
